import { render, staticRenderFns } from "./UserAvatar.vue?vue&type=template&id=2a7aa082&scoped=true"
import script from "./UserAvatar.vue?vue&type=script&lang=ts"
export * from "./UserAvatar.vue?vue&type=script&lang=ts"
import style0 from "./UserAvatar.vue?vue&type=style&index=0&id=2a7aa082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7aa082",
  null
  
)

export default component.exports